import { publishAnalyticsEvent as track } from '@fe-core-events';

type Event = {
  context: string;
  action: string;
};
type Properties<T> = T;

export const publishAnalyticsEvent = <T>(
  event: Event,
  properties?: Properties<T>,
) => {
  const analyticsEvent = {
    application: 'fe-learner-catalog',
    track: {
      event: event,
      properties: properties,
    },
  };

  if (process.env.NODE_ENV === 'development') {
    console.log('publishAnalyticsEvent', analyticsEvent);
  }

  track(analyticsEvent);
};
